import { useSelector } from "react-redux"
import { selectAppPersonalizations } from "../../../services/utils/appInfoSlice"
import ProgressBar from 'react-bootstrap/ProgressBar';



export default function Header(props) {

    const personalizations = useSelector(selectAppPersonalizations)

    return(
        <header>
            <div>
                <img src={personalizations?.logo_url} />
            </div>
            <ProgressBar now={props?.progress || 0} />
        </header>
    )
}